import { Grid, Image, Paper, Stack, Text } from '@mantine/core';
import React from 'react';
import styles from './styles.module.css';
import { useNavigate } from 'react-router-dom';

interface ApplicationItemProps {
  title: string;
  description: string;
  url: string;
}

const ApplicationItem: React.FC<ApplicationItemProps> = ({ description, title, url }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(url);
  };

  return (
    <Paper
      p={16}
      radius='lg'
      className={styles.applicationItem}
      withBorder
      onClick={handleNavigate}
    >
      <Grid gutter='lg'>
        <Grid.Col span='content'>
          <Image src='/logo/logo_icon-dacum.svg' h={48} w={48} />
        </Grid.Col>
        <Grid.Col span='auto'>
          <Stack gap='xs'>
            <Text fw={600}>{title}</Text>
            <Text fz={14} c={'secondary'} lineClamp={4}>
              {description}
            </Text>
          </Stack>
        </Grid.Col>
      </Grid>
    </Paper>
  );
};

export default ApplicationItem;
